module.exports = __webpack_public_path__ + "img/8.02feb4b4.jpg";